export enum ERightMenuType {
  Expert = 'expert',
  Client = 'client',
}
